import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/avatar-skeleton.svg'


const _withScopeId = n => (_pushScopeId("data-v-66852b96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "No avatar",
  class: "avatar-placeholder"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.finalPhotoURL && _ctx.effectiveProvider !== 'none')
    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
    : (_ctx.effectiveProvider === 'google')
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.finalPhotoURL,
          alt: `${_ctx.finalDisplayName} profile picture`,
          class: "avatar-placeholder"
        }, null, 8, _hoisted_2))
      : (_ctx.effectiveProvider === 'gravatar')
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _ctx.gravatarUrl,
            alt: `${_ctx.finalDisplayName} profile picture`,
            class: "avatar-placeholder"
          }, null, 8, _hoisted_3))
        : (_ctx.effectiveProvider === 'none')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              role: "img",
              "aria-label": `${_ctx.finalDisplayName} profile picture`,
              style: _normalizeStyle(_ctx.avatarStyle),
              class: "avatar-placeholder"
            }, _toDisplayString(_ctx.firstLetter), 13, _hoisted_4))
          : _createCommentVNode("", true)
}